import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { CurrentCourseProgress, FirstTutorialProgress } from '../models/student-progress.model';

@Injectable({
  providedIn: 'root',
})
export class StudentProgressService {
  private readonly http = inject(HttpClient);

  getCurrentInProgress(studentId: number): Observable<ApiResponse<CurrentCourseProgress | null>> {
    return this.http.get<ApiResponse<CurrentCourseProgress | null>>(
      `/api/v1/student-progress/student/${studentId}/current`
    );
  }

  getFirstTutorialProgress(studentCode: string): Observable<ApiResponse<FirstTutorialProgress | null>> {
    return this.http.get<ApiResponse<FirstTutorialProgress | null>>(
      `/api/v1/student-progress/by-code/${encodeURIComponent(studentCode)}/first-tutorial`
    );
  }
}
